import { PayPalButtons } from "@paypal/react-paypal-js";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React from "react";
import Loading from "../../../../components/Loading/Loading";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import useRenewSubscription from "../../../../hooks/useRenewSubscription";
import { useToggle } from "../../../../hooks/useToggle";
import localeText from "../../../../locale";
import paypalImg from "../../../../pages/images/paypal.png";
import masterCardImg from "../../../../pages/images/masterCard.png";
import americanExpress from "../../../../pages/images/expressoAmericano.png";
import visa from "../../../../pages/images/visa.png";
import PagamentoSeguro from "../../../images/pagamentoSeguro.png";

const RenewSubscription = ({ setSubscriptionInfo }) => {
  const { showErrorToast, showSuccessToast } = useToastContext();
  const {
    setAsFalse: setPopUpNotVisible,
    setAsTrue: setPopUpVisible,
    value: isPopUpVisible,
  } = useToggle();

  const {
    renewSubscriptionAmoutToPay,
    isLoadingRenewSubscriptionAmoutToPay,
    isLoadingRenewSubscription,
    handleRenewSubscription,
    freeRenewalsRemaining,
  } = useRenewSubscription({
    setPopUpNotVisible: setPopUpNotVisible,
    setSubscriptionInfo: setSubscriptionInfo,
    onSuccess: () => showSuccessToast({ detail: "subscriptionRenewed" }),
    onError: ({ code }) => showErrorToast({ code }),
  });

  return (
    <div className="card border-1 border-300">
      <h3 className="my-4">{localeText("renewSubscription")}</h3>
      <p>{`${localeText("freeRenewalsRemaining")}: ${freeRenewalsRemaining}`}</p>
      <hr />
      {isLoadingRenewSubscriptionAmoutToPay ? (
        <Loading classNameIcon={"text-4xl"} />
      ) : (
        <>
          <Dialog
            header={localeText("renewSubscription")}
            visible={isPopUpVisible}
            className="w-30rem m-2"
            onHide={() => {
              if (!isLoadingRenewSubscription) setPopUpNotVisible();
            }}
            draggable={false}
          >
            <p className="">
              {localeText("renewSubscriptionValue")}:{" "}
              <strong>
                {renewSubscriptionAmoutToPay.currency} {renewSubscriptionAmoutToPay.amountDue}
              </strong>
            </p>

            <p>{localeText("youWantRenewWalletBalance")}</p>
            <div className="flex gap-2 justify-content-end">
              <Button
                onClick={() => {
                  if (!isLoadingRenewSubscription) setPopUpNotVisible();
                }}
                severity="danger"
                disabled={isLoadingRenewSubscription}
                className={`${isLoadingRenewSubscription ? "opacity-80" : ""}`}
              >
                {localeText("no")}
              </Button>
              <Button
                onClick={() => {
                  handleRenewSubscription(4);
                }}
                disabled={isLoadingRenewSubscription}
                className={`${isLoadingRenewSubscription ? "opacity-80" : ""}`}
              >
                <div className="flex justify-content-center align-items-center gap-2">
                  {isLoadingRenewSubscription && (
                    <Loading classNameIcon={"text-sm"} disableMargin />
                  )}
                  <p>{localeText("yes")}</p>
                </div>
              </Button>
            </div>
          </Dialog>

          <div className="mt-5">
            <p className="text-xl text-center">{localeText("renewSubscriptionValue")}</p>
            <p className="text-5xl text-center">
              <strong>
                {renewSubscriptionAmoutToPay.currency} {renewSubscriptionAmoutToPay.amountDue}
              </strong>
            </p>
            <p className="text-2xl text-center">{localeText("paymentMethods")}:</p>

            <div className="flex flex-column justify-content-center mt-4 align-items-center">
              <Button
                className="text-sm border-round-md"
                style={{
                  marginBottom: "11px",
                  width: "200px",
                  minHeight: "35px",
                  padding: "0px",
                  border: "none",
                }}
                label={localeText("walletBalancerRenew")}
                onClick={setPopUpVisible}
              />
              <PayPalButtons
                createOrder={(data, actions) => {
                  return actions.order.create({
                    purchase_units: [
                      {
                        amount: {
                          value: renewSubscriptionAmoutToPay.paypalValue,
                        },
                      },
                    ],
                  });
                }}
                onApprove={(data, actions) => {
                  return actions.order.capture().then((details) => {
                    handleRenewSubscription(1, details.id); // details.id === transactionId
                  });
                }}
                onError={(e) => {
                  console.log(e);
                  showErrorToast({ detail: "errorRenewingSubscription" });
                }}
              />
            </div>

            <div className="flex mt-4 justify-content-center align-items-center w-full flex-wrap gap-2 mx-auto">
              <img
                src={paypalImg}
                alt="paypal"
                title="paypal"
                style={{ width: "20px", height: "20px" }}
              />
              <img
                src={americanExpress}
                alt="americanExpress"
                title="americanExpress"
                style={{ width: "20px", height: "20px" }}
              />
              <img
                src={masterCardImg}
                alt="mastercard"
                title="mastercard"
                style={{ width: "30px", height: "20px" }}
              />
              <img src={visa} alt="visa" style={{ width: "35px", height: "15px" }} title="visa" />
            </div>
            <div className="flex justify-content-center align-items-center gap-2 mt-3">
              <p className="m-0 text-xs">{localeText("safePayment")}</p>
              <img
                src={PagamentoSeguro}
                alt=""
                style={{ width: "20px" }}
                title={localeText("safePayment")}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default RenewSubscription;
